<template>
  <tr data-test="entryRow">
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <td><slot name="selection" /></td>
      <td>
        <div>
          {{ $t("people:ShoppingBasket.Payable.entry.label") }}
        </div>
        <div v-if="item.paymentInProcess" class="secondary--text">
          {{
            $t(
              "people:ShoppingBasket.ShoppingBasketTab.InProcess.text",
              "In process",
              "Label of the order table section"
            )
          }}
        </div>
      </td>
      <td class="muted--text">
        <div>
          {{
            $t(
              "people:ShoppingBasket.ShoppingBasketTab.Competition.label",
              "Competition",
              "Label of the order table section"
            )
          }}: {{ get(item.entry, "competition.code", "") }} |
          {{ get(item.entry, "competition.name", "") }}
        </div>
        <slot name="notAllowedReasons" />
      </td>
      <td style="width: 25%">
        {{ item.paymentDeadline ? $dayjs.date(item.paymentDeadline) : "" }}
      </td>
      <td class="text-right"><slot name="price" /></td>
      <td><slot name="actions" /></td>
    </template>
    <template v-else>
      <td style="font-size: 12px" colspan="99">
        <v-row dense class="align-center">
          <v-col cols="1" class="mr-3">
            <slot name="selection" />
          </v-col>
          <v-col>
            <div>
              {{ $t("people:ShoppingBasket.Payable.entry.label") }}
            </div>
            <div v-if="item.paymentInProcess" class="secondary--text">
              {{
                $t(
                  "people:ShoppingBasket.ShoppingBasketTab.InProcess.text",
                  "In process",
                  "Label of the order table section"
                )
              }}
            </div>

            <div class="muted--text">
              {{
                $t(
                  "people:ShoppingBasket.ShoppingBasketTab.Competition.label",
                  "Competition",
                  "Label of the order table section"
                )
              }}: {{ get(item.entry, "competition.code", "") }} |
              {{ get(item.entry, "competition.name", "") }}
            </div>
            <div v-if="item.paymentDeadline" class="secondary--text">
              <b>{{
                $t(
                  "people:ShoppingBasket.ShoppingBasketTab.Deadline.label",
                  "Deadline",
                  "Label of the order table section"
                )
              }}</b>
              &nbsp;
              {{ $dayjs.date(item.paymentDeadline) }}
            </div>
          </v-col>

          <div
            class="pa-1"
            style="
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            "
          >
            <slot name="price" />
          </div>
          <slot name="notAllowedReasons" />
        </v-row>
        <div class="pa-1 d-flex justify-end">
          <slot
            name="actions"
            :button-props="{
              small: false,
              xSmall: true
            }"
          />
        </div>
      </td>
    </template>
  </tr>
</template>
<script>
import { get } from "lodash-es";

export default {
  name: "EntryProductOrderDetails",
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    get: () => get
  }
};
</script>
